<template>
  <div>
    <section class="section">
      <div class="container">
        <TituloPrincipal :titulo="titulo" :subtitulo="subtitulo"/>
        <form @submit.prevent>
          <div class="columns is-multiline is-centered">
            <div class="column is-4">
              <b-field
                label="Nombre de Usuario"
                :type="{'is-danger': errors.has('nombre de usuario')}"
                :message="errors.first('nombre de usuario')"
              >
                <b-input
                  autofocus
                  v-model="username"
                  name="nombre de usuario"
                  v-validate="{ required: true, max: 255, regex: /^([a-zA-Z]|\d|_|-|[.])+$/ }"
                  v-on:keyup.enter="register()"
                />
              </b-field>

              <b-field
                label="Contraseña"
                :type="{'is-danger': errors.has('contraseña')}"
                :message="errors.first('contraseña')"
              >
                <b-input
                  type="password"
                  v-model="contrasena"
                  name="contraseña"
                  v-validate="'required|min:8'"
                  v-on:keyup.enter="register()"
                />
              </b-field>

              <b-field
                label="Confirmar contraseña"
                :type="{'is-danger': errors.has('confirmar contraseña')}"
                :message="errors.first('confirmar contraseña')"
              >
                <b-input
                  type="password"
                  v-model="confirmarContrasena"
                  name="confirmar contraseña"
                  v-validate="{ required: true, is: contrasena }"
                  v-on:keyup.enter="register()"
                />
              </b-field>

              <b-field
                label="Tipo Documento"
                :type="{'is-danger': errors.has('tipo documento')}"
                :message="errors.first('tipo documento')"
              >
                <b-select
                  v-model="tipoDocumento"
                  name="tipo documento"
                  placeholder="Tipo"
                  v-validate="'required|included:DNI,PAS,LE,LC'"
                  v-on:keyup.enter="register()"
                >
                  <option value="DNI">DNI</option>
                  <option value="PAS">Pasaporte</option>
                  <option value="LE">LE</option>
                  <option value="LC">LC</option>
                </b-select>
              </b-field>

              <b-field
                label="Documento"
                :type="{'is-danger': errors.has('documento')}"
                :message="errors.first('documento')"
              >
                <b-input
                  v-model="documento"
                  name="documento"
                  v-validate="{ required: true, min: 5, max: 30, regex: /^([a-zA-Z]|\d)+$/ }"
                  v-on:keyup.enter="register()"
                />
              </b-field>
            </div>
            <div class="column is-4">
              <b-field
                label="Correo electrónico"
                :type="{'is-danger': errors.has('correo electrónico')}"
                :message="errors.first('correo electrónico')"
              >
                <b-input
                  v-model="email"
                  name="correo electrónico"
                  v-validate="'required|email'"
                  v-on:keyup.enter="register()"
                />
              </b-field>

              <b-field
                label="Confirmar correo electrónico"
                :type="{'is-danger': errors.has('confirmar correo electrónico')}"
                :message="errors.first('confirmar correo electrónico')"
              >
                <b-input
                  v-model="confirmarEmail"
                  name="confirmar correo electrónico"
                  v-validate="{ required: true, is: email }"
                  v-on:keyup.enter="register()"
                />
              </b-field>

              <b-field
                label="Nombre"
                :type="{'is-danger': errors.has('nombre')}"
                :message="errors.first('nombre')"
              >
                <b-input
                  v-model="nombre"
                  name="nombre"
                  v-validate="{ required: true, min: 2, max: 50, regex: /^([a-zA-Z]|á|é|í|ó|ú|[ ]|ñ|Ñ|ü)+$/ }"
                  v-on:keyup.enter="register()"
                />
              </b-field>

              <b-field
                label="Apellido"
                :type="{'is-danger': errors.has('apellido')}"
                :message="errors.first('apellido')"
              >
                <b-input
                  v-model="apellido"
                  name="apellido"
                  v-validate="{ required: true, min: 2, max: 50, regex: /^([a-zA-Z]|á|é|í|ó|ú|[ ]|ñ|Ñ|ü)+$/ }"
                  v-on:keyup.enter="register()"
                />
              </b-field>

              <b-field
                label="Sexo"
                :type="{'is-danger': errors.has('sexo')}"
                :message="errors.first('sexo')"
              >
                <b-select
                  v-model="sexo"
                  name="sexo"
                  placeholder="Seleccione"
                  v-validate="'required|included:FEM,MASC,OTRO'"
                  v-on:keyup.enter="register()"
                >
                  <option value="MASC">MASCULINO</option>
                  <option value="FEM">FEMENINO</option>
                  <option value="OTRO">OTRO</option>
                </b-select>
              </b-field>
            </div>
            <div class="column is-4">
              <b-field
                label="Dirección"
                :type="{'is-danger': errors.has('dirección')}"
                :message="errors.first('dirección')"
              >
                <b-input
                  v-model="direccion"
                  name="dirección"
                  v-validate="{ required: true, min: 5, max: 50, regex: /^([a-zA-Z]|\d|á|é|í|ó|ú|[ ]|ñ|ü)+$/ }"
                  v-on:keyup.enter="register()"
                />
              </b-field>
              <b-field
                label="Teléfono"
                :type="{'is-danger': errors.has('teléfono')}"
                :message="errors.first('teléfono')"
              >
                <b-input
                  v-model="telefono"
                  type="tel"
                  name="teléfono"
                  v-validate="{ required: true, min: 7, max: 50, regex: /^([[0-9 +]|[(]|[)]|[-])+$/ }"
                  v-on:keyup.enter="register()"
                />
              </b-field>
              <b-field
                label="Localidad"
                :type="{'is-danger': errors.has('localidad')}"
                :message="errors.first('localidad')"
              >
                <b-input
                  v-model="localidad"
                  name="localidad"
                  v-validate="{ required: true, min: 2, max: 50, regex: /^([a-zA-Z]|á|é|í|ó|ú|[ ]|ñ|Ñ|ü)+$/ }"
                  v-on:keyup.enter="register()"
                />
              </b-field>
              <b-field
                label="Provincia"
                :type="{'is-danger': errors.has('provincia')}"
                :message="errors.first('provincia')"
              >
                <b-input
                  v-model="provincia"
                  name="provincia"
                  v-validate="{ required: true, min: 5, max: 50, regex: /^([a-zA-Z]|á|é|í|ó|ú|[ ]|ñ|Ñ|ü)+$/ }"
                  v-on:keyup.enter="register()"
                />
              </b-field>
            </div>
          </div>

          <b-field
            label="Verificación"
            :type="{'is-danger': !recaptchaVerified}"
            :message="{'Debe validar que es humano': !recaptchaVerified && showErrorRecaptcha, '': recaptchaVerified}"
          >
            <template>
              <vue-recaptcha
                :sitekey="keyRecaptcha"
                @verify="markRecaptchaAsVerified"
                @expired="markRecaptchaAsNotVerified"
              ></vue-recaptcha>
            </template>
          </b-field>
          <b-field
            label
            :type="{'is-danger': errors.has('terminos')}"
            :message="errors.first('terminos')"
          >
            <b-checkbox v-model="terminos" name="terminos" v-validate="'required:false'">
              Acepto los
              <router-link
                :to="{name: 'politica-privacidad'}"
                target="_blank"
              >términos y condiciones</router-link>
            </b-checkbox>
          </b-field>

          <button
            class="button is-secundary"
            v-bind:class="{'is-loading': isLoading}"
            @click="register()"
            v-on:keyup.enter="register()"
          >Registrarse</button>
        <b-loading :is-full-page="true" :active.sync="isLoading" :can-cancel="false"></b-loading>
        </form>
      </div>
    </section>
  </div>
</template>

<script>
import TituloPrincipal from '@/components/TituloPrincipal.vue'
import VueRecaptcha from 'vue-recaptcha'

export default {
  name: 'Register',
  data () {
    return {
      titulo: 'Registro',
      subtitulo: 'Ingrese los datos solicitados',
      username: null,
      email: null,
      confirmarEmail: null,
      contrasena: null,
      confirmarContrasena: null,
      tipoDocumento: null,
      documento: null,
      nombre: null,
      apellido: null,
      sexo: null,
      direccion: null,
      telefono: null,
      localidad: null,
      provincia: null,
      terminos: false,
      isLoading: false,
      recaptchaVerified: false,
      showErrorRecaptcha: false,
      keyRecaptcha: process.env.VUE_APP_RECAPTCHA_PUBLIC_KEY,
      recaptchaToken: null,
      monthNames: ['Enero', 'Febrero', 'Marzo', 'Abril', 'Mayo', 'Junio', 'Julio', 'Agosto', 'Septiembre', 'Octubre', 'Noviembre', 'Diciembre']

    }
  },
  components: {
    TituloPrincipal,
    VueRecaptcha
  },
  methods: {
    markRecaptchaAsVerified (token) {
      this.recaptchaVerified = true
      this.recaptchaToken = token
    },
    markRecaptchaAsNotVerified () {
      this.recaptchaVerified = false
    },
    register () {
      this.showErrorRecaptcha = true
      var componenteVue = this
      this.isLoading = true

      function registrarCallback (error, data) {
        componenteVue.isLoading = false
        if (error) {
          componenteVue.$buefy.dialog.alert({
            title: 'Error - ' + error.response.data.status,
            message: error.response.data.message,
            type: 'is-danger',
            hasIcon: true,
            icon: 'close-circle-outline',
            iconPack: 'mdi'
          })
        } else {
          componenteVue.$buefy.dialog.alert({
            title: 'Usuario creado',
            message: data.message,
            type: 'is-success',
            hasIcon: true,
            icon: 'account-check',
            iconPack: 'mdi',
            onConfirm: () => componenteVue.$router.push({ name: 'inicio' })
          })
        }
      }

      // Valida el form (y valida el recaptcha)
      this.$validator.validateAll().then(result => {
        // Si esta todo bien realiza el llamado a registrar usuario en la api y ejecuta callback
        if (result && this.recaptchaVerified) {
          // Crea el json
          const jsonData = {
            username: this.username,
            email: this.email,
            contrasena: this.contrasena,
            confirmarContrasena: this.confirmarContrasena,
            tipoDocumento: this.tipoDocumento,
            documento: this.documento,
            nombre: this.nombre,
            apellido: this.apellido,
            sexo: this.sexo,
            direccion: this.direccion,
            telefono: this.telefono,
            localidad: this.localidad,
            provincia: this.provincia,
            recaptchaToken: this.recaptchaToken
          }

          // Ejecuta llamdo sobre api
          componenteVue.$apiService.registrarUsuario(jsonData, registrarCallback)
        } else { // Sino renderiza toast con error
          this.isLoading = false
          componenteVue.$buefy.toast.open({
            message: 'Revise los datos',
            type: 'is-danger',
            position: 'is-top'
          })
        }
      })
    }
  },
  beforeCreate () {
    // Agrega recaptcha js
    const recaptcha = document.createElement('script')
    recaptcha.setAttribute(
      'src',
      'https://www.google.com/recaptcha/api.js?hl=es-419&onload=vueRecaptchaApiLoaded&render=explicit'
    )
    recaptcha.setAttribute('async', true)
    recaptcha.setAttribute('defer', true)
    document.head.appendChild(recaptcha)
  },
  mounted () {
    const dict = {
      custom: {
        provincia: {
          regex: 'Solo se pueden usar letras, acentos y espacios'
        },
        localidad: {
          regex: 'Solo se pueden usar letras, acentos y espacios'
        },
        teléfono: {
          regex:
            'Solo se pueden usar números, paréntesis, espacios y el signo +'
        },
        dirección: {
          regex: 'Solo se pueden usar letras, acentos, espacios y números'
        },
        apellido: {
          regex: 'Solo se pueden usar letras, acentos y espacios'
        },
        nombre: {
          regex: 'Solo se pueden usar letras, acentos y espacios'
        },
        documento: {
          regex: 'Solo se admiten números y letras'
        },
        'confirmar contraseña': {
          is: 'Las contraseñas no coinciden'
        },
        'nombre de usuario': {
          regex: 'Solo se pueden usar letras, números, guiones y puntos'
        },
        terminos: {
          required: 'Debe aceptar nuestra política de privacidad'
        }
      }
    }

    this.$validator.localize('es', dict)
  }
}
</script>
